import React, { Component } from 'react';
import { Tabs, Tab, Button, ButtonToolbar, Col } from 'react-bootstrap';
import Toggle from 'react-toggle'
import { ExportToCsv } from 'export-to-csv'

import { PropTypes } from 'prop-types';
import { StopsCommand } from '../commands/StopsCommand';
import { StopsDraftCommand } from '../commands/StopsDraftCommand';
import { StopActiveForm } from './StopActiveForm';
import { StopDraftForm } from './StopDraftForm';
import { StopsActive } from './StopsActive';
import { StopsDraft } from './StopsDraft';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { StopsMapViewer } from './StopsMapViewer';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

export class Stops extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    stops: [],
                },
                draft: {
                    stops: [],
                }
            },
            form: {
                active: {
                    stop: undefined
                },
                draft: {
                    stop: undefined
                },
                map: {
                    show: false,
                    active: [],
                    draft: []
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 10
                },
                draft: {
                    page: 1,
                    elementsPerPage: 10
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isExporting: false,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isExporting: false,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingEditions: false
            },
            commands: {
                active: {
                    stops: new StopsCommand(),
                },
                draft: {
                    stops: new StopsDraftCommand(),
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        // Add as observer
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getStops(edition, "active");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getStops(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    updateStopSuccessCallback(result, stopId, property, dataType) {
        const { data } = this.state;

        const stop = data[dataType].stops.find(stop => stop.id === stopId);
        if(undefined === stop) {
            return;
        }

        stop[property] = result;

        this.setState({
            data: data
        });
    }

    // ----------------------

    exportToCsv(isToExport, dataType) {
        const { data } = this.state;

        if (!isToExport || !Array.isArray(data[dataType].stops) || 0 === data[dataType].stops.length) {
            return;
        }

        const options = {
            fieldSeparator: ';',
            filename: "stops",
            showLabels: true,
            title: "Stops",
            useKeysAsHeaders: true
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data[dataType].stops);
    }

    // ----------------------

    getStopLines(stop, dataType) {
        if(undefined === stop) {
            return;
        }

        const { edition } = this.context;
        const { commands } = this.state;

        commands[dataType].stops.getStopLines(
            edition,
            stop.id,
            (a) => this.updateStopSuccessCallback(a, stop.id, "lines", dataType)
        );
    }

    getStopMunicipality(stop, dataType) {
        if(undefined === stop) {
            return;
        }

        const { edition } = this.context;
        const { commands } = this.state;

        commands[dataType].stops.getStopMunicipality(
            edition,
            stop.id,
            (a) => this.updateStopSuccessCallback(a, stop.id, "municipality", dataType)
        );
    }

    getStops(edition, dataType, isToExport = false) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        let updateAction = "isLoading";
        if (isToExport) {
            updateAction = "isExporting";
        }

        actions[dataType][updateAction] = true;
        commands[dataType].stops.get(
            edition,
            selectedProviderId,
            isToExport,
            (a) => this.listSuccessCallback(a, dataType, "stops", updateAction, () => this.exportToCsv(isToExport, dataType)),
            (a) => this.listErrorCallback(a, dataType, "stops", updateAction)
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].stop.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].stop.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].stop.obj[value] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].stop = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                code: "",
                name: "",
                shortName: "",
                extCode: "",
                externalCode: "",
                isActive: false,
                latitude: "",
                longitude: ""
            },
            codeInputError: null,
            nameInputError: null,
            latitudeInputError: null,
            longitudeInputError: null
        };

        this.setState({
            form: form
        });
    }

    onEditStopClick(stop, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            stop = data[dataType].stops.find(unmutedStop => unmutedStop.id === stop.id);
        }

        form[dataType].stop = {
            title: "Editar",
            type: "edit",
            original: stop,
            obj: Object.assign({
                id: 0,
                code: "",
                name: "",
                shortName: "",
                extCode: "",
                externalCode: "",
                isActive: false,
                latitude: "",
                longitude: ""
            }, stop),
            codeInputError: null,
            nameInputError: null,
            latitudeInputError: null,
            longitudeInputError: null
        };

        this.setState({
            form: form
        });
    }

    onStopFormExit(dataType) {
        const { form } = this.state;

        form[dataType].stop = undefined;

        this.setState({
            form: form
        });
    }

    onDeleteClick(stop, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a paragem "${stop.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: stop.id,
                    dataType: dataType
                }
            }
        });
    }

    onSaveStop(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdating = true;

            const callback = () => this.getStops(edition, dataType);
            commands[dataType].stops.save(
                edition,
                form[dataType].stop.obj,
                (a) => this.operationSuccessCallback(a, "isUpdating", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onStopFormExit(dataType);
        }
    }

    onExportClick(dataType) {
        const { edition } = this.context;

        this.getStops(edition, dataType, true);
    }

    onMapViewerClick() {
        const { data, form } = this.state;

        form.map.show = true;

        form.map.active = [];
        data.active.stops.forEach((stop) => {
            form.map.active.push(Object.assign({ position: [stop.latitude, stop.longitude] }, stop));
        });

        form.map.draft = [];
        data.draft.stops.forEach((stop) => {
            form.map.draft.push(Object.assign({ position: [stop.latitude, stop.longitude] }, stop));
        });

        this.setState({
            form: form
        });
    }

    onHideMapViewer(reload, message) {
        const { form } = this.state;

        form.map.show = false;

        if(undefined !== message) {
            this.setState({
                message: message
            });
        }

        if(reload) {
            const { edition } = this.context;

            this.getStops(edition, "active");
            this.getStops(edition, "draft");
        }

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions[argument.dataType].isDeleting = true;
                    commands[argument.dataType].stops.delete(
                        edition,
                        argument.id,
                        (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getStops(edition, argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        form[dataType].stop.codeInputError = null;
        form[dataType].stop.nameInputError = null;
        form[dataType].stop.latitudeInputError = null;
        form[dataType].stop.longitudeInputError = null;

        if (undefined === form[dataType].stop.obj.code || null === form[dataType].stop.obj.code || "" === form[dataType].stop.obj.code) {
            form[dataType].stop.codeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].stop.obj.name || null === form[dataType].stop.obj.name || "" === form[dataType].stop.obj.name) {
            form[dataType].stop.nameInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].stop.obj.latitude || null === form[dataType].stop.obj.latitude || "" === form[dataType].stop.obj.latitude || isNaN(form[dataType].stop.obj.latitude)) {
            form[dataType].stop.latitudeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].stop.obj.longitude || null === form[dataType].stop.obj.longitude || "" === form[dataType].stop.obj.longitude || isNaN(form[dataType].stop.obj.longitude)) {
            form[dataType].stop.longitudeInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // ----------------------

    renderMapViewer() {
        const { edition } = this.context;
        const { form } = this.state;

        return (
            <StopsMapViewer stops={form.map}
                edition={edition}
                onHide={(a, b) => this.onHideMapViewer(a, b)}
                onSaveStops={(a) => this.onSaveStopsFromMapViewer(a)} />
        );
    }

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.stop) {
            return null;
        }

        return (
            <StopActiveForm show={true}
                form={form.active.stop}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "active")}
                onSave={() => this.onSaveStop("active")}
                onHide={() => this.onStopFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.stop) {
            return null;
        }

        return (
            <StopDraftForm show={true}
                form={form.draft.stop}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "draft")}
                onSave={() => this.onSaveStop("draft")}
                onHide={() => this.onStopFormExit("draft")} />
        );
    }

    renderStopsActive() {
        const { data, actions, render, pagination } = this.state;

        return (
            <StopsActive stops={data.active.stops}
                draftStops={data.draft.stops}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isLoading || (render.compare && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                getStopLines={(a) => this.getStopLines(a, "active")}
                getStopMunicipality={(a) => this.getStopMunicipality(a, "active")}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditStopClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderStopsDraft() {
        const { data, actions, pagination, render } = this.state;

        if (actions.draft.isLoading) {
            return (<LoadingSpinner />)
        }

        return (
            <StopsDraft stops={data.draft.stops}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isLoading}
                filter={render.filter}
                isComparing={render.compare}
                getStopLines={(a) => this.getStopLines(a, "draft")}
                getStopMunicipality={(a) => this.getStopMunicipality(a, "draft")}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditStopClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderStopsActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderStopsDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onMapViewerClick()}>VER PARAGENS NO MAPA</Button>
                    <Button onClick={() => this.onExportClick("active")}>EXPORTAR</Button>
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onMapViewerClick()}>VER PARAGENS NO MAPA</Button>
                    <Button onClick={() => this.onExportClick("draft")}>EXPORTAR</Button>
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Paragens" showSeparator={true}>
                    <Col className="padding-0" xs={8} sm={7} md={7}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={4} sm={5} md={5}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}
                {this.renderMapViewer()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isExporting || actions.active.isUpdating || actions.active.isDeleting || actions.draft.isExporting || actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/Stops.js